import AppConstants from '../config/app.constants';

let PhysicalCashCountService = function ($http, $q) {

    let getFundingSource = (branchId) => {
        return $http
            .get(AppConstants.api + `/physical-cash-count/get-funding-source`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let commitPhysicalCashCount = (cashCountDetails, branchId, userId, currencyId, notes, vaultDate) => {
        return $http
            .post(AppConstants.api + `/physical-cash-count/commit-physical-cash-count`, {
                cashCountDetails,
                branchId,
                userId,
                currencyId,
                notes,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    };

    let findRequirementOrBalanceCount = (branchId, fundingSourceData, vaultDate) => {
        return $http
            .get(AppConstants.api + `/physical-cash-count/find-requirements-or-balance-count`, {
                params: {
                    branchId,
                    fundingSourceData,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let editPhysicalCashCount = (cashCountDetails, balanceCheckIds, userId, branchId, currencyId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/physical-cash-count/edit-physical-cash-count`, {
                cashCountDetails,
                balanceCheckIds,
                userId,
                branchId,
                currencyId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    };

    let checkForVariance = (data) => {
        return $http
            .post(AppConstants.api + `/physical-cash-count/check-for-variance`, {
                data
            })
            .then((res) => {
                return res.data
            })
    };

    let approvePhysicalCashCount = (vaultDate, fundingSourceId, branchId, userId, totalAmount, variance, denominations) => {
        return $http
            .post(AppConstants.api + `/physical-cash-count/approve-physical-cash-count`, {
                vaultDate, fundingSourceId, branchId, userId, totalAmount, variance, denominations
            })
            .then((res) => {
                return res.data
            })
    };

    return {
        getFundingSource,
        commitPhysicalCashCount,
        findRequirementOrBalanceCount,
        editPhysicalCashCount,
        checkForVariance,
        approvePhysicalCashCount
    }
}

PhysicalCashCountService.$inject = ['$http', '$q'];

export default PhysicalCashCountService;


// WEBPACK FOOTER //
// ./client/app/services/physical-cash-count.service.js